import React, { useState, useEffect } from "react";
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, TextField,
    Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, Select, InputLabel, FormControl
} from "@mui/material";
import axios, { decryptData, removeBracketedText } from '../Axiosinstance';
import { useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import Teacher_Deployment from '../pdf/TIMETABLE.pdf';
import { buttonBackgroundColor } from "../common";
// import { removeBracketedText } from "../Axiosinstance";

const Timetable = () => {
    const { batchId, intakeId } = useParams();
    const batchId1 = decryptData(decodeURIComponent(batchId));
    const intakeId1 = decryptData(decodeURIComponent(intakeId));

    const [timetableData, setTimetableData] = useState(null);
    const [isEditOpen, setIsEditOpen] = useState(false);
    const [editData, setEditData] = useState({
        startDate: '',
        endDate: '',
        days: [],
        startTime: '',
        endTime: '',
    });

    const [selectedSchedule, setSelectedSchedule] = useState(null);

    const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    useEffect(() => {
        axios
            .get(`/timetable/search?intakeId=${intakeId1}&batchId=${batchId1}`)
            .then((response) => {
                setTimetableData(response.data);
            })
            .catch((error) => {
                console.error("Error fetching the timetable data:", error);
            });
    }, [batchId1, intakeId1]);

    const handleEditClick = (schedule) => {
        setSelectedSchedule(schedule);
        setEditData({
            startDate: schedule.startDate,
            endDate: schedule.endDate,
            days: schedule.days,
            startTime: schedule.startTime,
            endTime: schedule.endTime,
        });
        setIsEditOpen(true);
    };

    const handleSaveEdit = () => {
        // Make API call to update the schedule
        axios
            .put(`/timetable/${timetableData.id}/schedule/${selectedSchedule.id}`, editData)
            .then((response) => {
                // Show success message
                toast.success('Schedule updated successfully!');
                setIsEditOpen(false);

                // Refetch timetable data
                axios
                    .get(`/timetable/search?intakeId=${intakeId1}&batchId=${batchId1}`)
                    .then((response) => {
                        setTimetableData(response.data);
                    })
                    .catch((error) => {
                        console.error("Error fetching the timetable data:", error);
                        toast.error('Failed to refetch timetable data.');
                    });
            })
            .catch((error) => {
                console.error("Error updating the schedule:", error);
                toast.error('Failed to update schedule.');
            });
    };

    const formatTimeTo12Hour = (time) => {
        if (!time) return 'N/A';


        const [hours, minutes] = time.split(':');
        if (!hours || !minutes) return 'N/A';

        // Create a Date object from the time string, assuming a constant date
        const date = new Date();
        date.setHours(parseInt(hours, 10));
        date.setMinutes(parseInt(minutes, 10));
        date.setSeconds(0); // Assuming seconds are not provided in the time string

        // Define options for formatting time in 12-hour format
        const options = { hour: '2-digit', minute: '2-digit', hour12: true };
        return date.toLocaleTimeString('en-US', options);
    };

    const wrapText = (text, maxWidth, font, fontSize) => {
        const words = text.split(' ');
        let lines = [];
        let currentLine = '';

        words.forEach(word => {
            const testLine = currentLine + (currentLine.length ? ' ' : '') + word;
            const width = font.widthOfTextAtSize(testLine, fontSize);

            if (width > maxWidth) {
                lines.push(currentLine);
                currentLine = word;
            } else {
                currentLine = testLine;
            }
        });

        if (currentLine) {
            lines.push(currentLine);
        }

        return lines;
    };



    // const handleDownloadPDF = async () => {
    //     try {
    //         const existingPdfBytes = await fetch(Teacher_Deployment).then(res => res.arrayBuffer());
    //         const pdfDoc = await PDFDocument.load(existingPdfBytes);

    //         const pages = pdfDoc.getPages();
    //         const firstPage = pages[0];
    //         const { width, height } = firstPage.getSize();
    //         const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
    //         const fontSize = 11;



    //         // Draw course and intakeId
    //         firstPage.drawText(`${timetableData.course.toUpperCase()}`, {
    //             x: 150,
    //             y: 482.5,
    //             size: fontSize,
    //             font,
    //             color: rgb(0, 0, 0),
    //         });

    //         firstPage.drawText(` ${intakeId1}`, {
    //             x: 630,
    //             y: 482.5,
    //             size: fontSize,
    //             font,
    //             color: rgb(0, 0, 0),
    //         });

    //         // Continue with your existing drawing code...

    //         let yPosition = height - 230; // Start position for writing data
    //         const maxWidth = 250; // Maximum width for text wrapping

    //         let ymodule = 394; // Start position for the first schedule entry
    //         const modulelineHeight = 43.5;

    //         const getTextWidth = (text, font, fontSize) => {
    //             const width = font.widthOfTextAtSize(text, fontSize);
    //             return width;
    //         };

    //         function replaceTabs(text) {
    //             return text.replace(/\t/g, '    '); // Replace each tab with four spaces
    //         }

    //         const drawWrappedText = async (page, text, x, y, font, fontSize, maxWidth) => {
    //             text = replaceTabs(text);
    //             const lines = [];
    //             let currentLine = '';
    //             const words = text.split(' ');

    //             for (let i = 0; i < words.length; i++) {
    //                 const word = words[i];
    //                 const width = getTextWidth(currentLine + ' ' + word, font, fontSize);

    //                 if (width < maxWidth) {
    //                     currentLine += (currentLine === '' ? '' : ' ') + word;
    //                 } else {
    //                     lines.push(currentLine.trim());
    //                     currentLine = word;
    //                 }
    //             }

    //             if (currentLine !== '') {
    //                 lines.push(currentLine.trim());
    //             }

    //             for (let i = 0; i < lines.length; i++) {
    //                 const line = lines[i].trim();
    //                 const lineWidth = getTextWidth(line, font, fontSize);

    //                 await page.drawText(line, {
    //                     x: i === 0 ? x : x,  // Keep the initial X position for all lines
    //                     y: y - i * 12,       // Adjust the line height as needed
    //                     size: fontSize,
    //                     font,
    //                     color: rgb(0, 0, 0),
    //                 });
    //             }
    //         };

    //         timetableData.scheduleDateDetails.forEach((schedule) => {
    //             const matchingModule = timetableData.moduleDetails.find(
    //                 (module) => module.id === schedule.startModulus
    //             );
    //             const moduleName = matchingModule.moduleName;

    //             drawWrappedText(firstPage, moduleName, 96, ymodule, font, 10, 130);
    //             ymodule -= modulelineHeight; // Move down for the next entry
    //         });

    //         timetableData.scheduleDateDetails.forEach((schedule) => {
    //             const matchingModule = timetableData.moduleDetails.find(
    //                 (module) => module.id === schedule.startModulus
    //             );

    //             firstPage.drawText(`${schedule.startDate ? new Date(schedule.startDate).toLocaleDateString('en-GB') : 'N/A'}`, { x: 230, y: yPosition, size: fontSize, font });
    //             firstPage.drawText(`${schedule.endDate ? new Date(schedule.endDate).toLocaleDateString('en-GB') : 'N/A'}`, { x: 300, y: yPosition, size: fontSize, font });
    //             firstPage.drawText(`${removeBracketedText(schedule.trainer)}`, { x: 490, y: yPosition, size: fontSize, font });
    //             firstPage.drawText(`${schedule.endDate ? new Date(schedule.endDate).toLocaleDateString('en-GB') : 'N/A'}`, { x: 600, y: yPosition, size: fontSize, font });

    //             const startTimeText = formatTimeTo12Hour(schedule.startTime);
    //             const endTimeText = formatTimeTo12Hour(schedule.endTime);
    //             const toText = 'TO';

    //             const timeYPosition = yPosition + 12;

    //             firstPage.drawText(startTimeText, { x: 375, y: timeYPosition, size: fontSize, font });

    //             const toWidth = font.widthOfTextAtSize(toText, fontSize);
    //             const startTimeWidth = font.widthOfTextAtSize(startTimeText, fontSize);
    //             const endTimeWidth = font.widthOfTextAtSize(endTimeText, fontSize);
    //             const maxWidth = Math.max(startTimeWidth, endTimeWidth);
    //             const toX = 375 + (maxWidth - toWidth) / 2;
    //             firstPage.drawText(toText, { x: toX, y: timeYPosition - 15, size: fontSize, font });

    //             firstPage.drawText(endTimeText, { x: 375, y: timeYPosition - 30, size: fontSize, font });

    //             const venueText = schedule.venue === 'Online/Classroom' ? 'Online' : schedule.venue;
    //             firstPage.drawText(venueText, { x: 690, y: yPosition, size: 11, font });

    //             const daysText = schedule.days.length > 0 ? schedule.days.join(', ') : 'N/A';
    //             const wrappedLines = wrapText(daysText, maxWidth, font, 8);
    //             // console.log(daysText)

    //             const xBase = 431; // Starting x position
    //             const yBase = yPosition; // Adjust this value to change the starting position for text
    //             const xOffsetIncrement = 0; // Set to zero if horizontal adjustment is not needed
    //             const yLineSpacing = fontSize + 5; // Adjust line spacing as needed

    //             // Adjust yBase for the starting point (e.g., increase yBase to move text lower)
    //             // const adjustedYBase = yBase ; // Move text 50 units down (lower position)

    //             // Draw the wrapped lines
    //             wrappedLines.forEach((line, index) => {
    //                 // Calculate the new x and y positions for each line
    //                 const xPosition = xBase + (index * xOffsetIncrement);
    //                 const yPositionAdjusted = yBase - (index * yLineSpacing); // Adjust for line spacing

    //                 // Log positions for debugging
    //                 console.log(`Line ${index + 1}: x=${xPosition}, y=${yPositionAdjusted}`);

    //                 // Draw the line with the updated positions
    //                 firstPage.drawText(line, {
    //                     x: xPosition,
    //                     y: yPositionAdjusted,
    //                     size: 10,
    //                     font,
    //                     color: rgb(0, 0, 0),
    //                 });
    //             });


    //             yPosition -= 43; // Move to the next line
    //         });


    //         // Serialize the PDF to bytes
    //         const pdfBytes = await pdfDoc.save();

    //         const blob = new Blob([pdfBytes], { type: 'application/pdf' });
    //         const url = URL.createObjectURL(blob);

    //         // Open the PDF in a new tab
    //         window.open(url, '_blank');
    //     } catch (error) {
    //         console.error('Error generating PDF:', error);
    //     }
    // };


    const handleDownloadPDF = async () => {
        try {
            const existingPdfBytes = await fetch(Teacher_Deployment).then(res => res.arrayBuffer());
            const pdfDoc = await PDFDocument.load(existingPdfBytes);
            const pages = pdfDoc.getPages();
            const firstPage = pages[0];
            const { width, height } = firstPage.getSize();
            const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
            const fontSize = 10;

            // Draw course and intakeId
            firstPage.drawText(`${timetableData.course.toUpperCase()}`, { x: 150, y: 482.5, size: fontSize, font, color: rgb(0, 0, 0) });
            firstPage.drawText(` ${intakeId1}`, { x: 630, y: 482.5, size: fontSize, font, color: rgb(0, 0, 0) });

            let yPosition = height - 220;
            const moduleLineHeight = 43.5;
            const maxTrainerWidth = 100; // Set max width for trainer name
            const lineHeight = 10; // Line height for wrapped text

            const getTextWidth = (text, font, fontSize) => font.widthOfTextAtSize(text, fontSize);

            const drawWrappedText = (page, text, x, y, font, fontSize, maxWidth) => {
                const words = text.split(" ");
                const lines = [];
                let currentLine = "";

                words.forEach((word) => {
                    const width = getTextWidth(`${currentLine} ${word}`, font, fontSize);
                    if (width < maxWidth) {
                        currentLine += (currentLine === "" ? "" : " ") + word;
                    } else {
                        lines.push(currentLine);
                        currentLine = word;
                    }
                });
                if (currentLine) lines.push(currentLine);

                lines.forEach((line, i) => {
                    page.drawText(line, { x, y: y - i * lineHeight, size: fontSize, font, color: rgb(0, 0, 0) });
                });

                return lines.length * lineHeight; // Return total height occupied
            };

            // New function to draw days text split by commas
            const drawWrappedText1 = (page, text, x, y, font, fontSize) => {
                const lines = text.split(","); // Split text by comma
                let yOffset = 0;

                lines.forEach((line) => {
                    page.drawText(line.trim(), { x, y: y - yOffset, size: fontSize, font, color: rgb(0, 0, 0) });
                    yOffset += fontSize + 2; // Move to the next line
                });

                return lines.length * (fontSize + 2); // Return total height occupied
            };


            const drawWrappedText2 = (page, text, x, y, font, fontSize) => {
                const lines = text.split(","); // Split text by comma
                let yOffset = 0;

                lines.forEach((line) => {
                    page.drawText(line.trim(), { x, y: y - yOffset, size: fontSize, font, color: rgb(0, 0, 0) });
                    yOffset += fontSize + 1; // Move to the next line
                });

                return lines.length * (fontSize + 1); // Return total height occupied
            };

            timetableData.scheduleDateDetails.forEach((schedule) => {
                const matchingModule = timetableData.moduleDetails.find((module) => module.id === schedule.startModulus);
                const moduleName = matchingModule ? matchingModule.moduleName : "N/A";

                // Draw module name
                drawWrappedText(firstPage, moduleName, 94, yPosition, font, 11, 130);

                // Draw start and end dates
                firstPage.drawText(`${schedule.startDate ? new Date(schedule.startDate).toLocaleDateString('en-GB') : 'N/A'}`, { x: 232, y: yPosition, size: fontSize, font });
                firstPage.drawText(`${schedule.endDate ? new Date(schedule.endDate).toLocaleDateString('en-GB') : 'N/A'}`, { x: 302, y: yPosition, size: fontSize, font });

                // Wrap Trainer Name and get height
                const trainerName = removeBracketedText(schedule.trainer);
                const trainerTextHeight = drawWrappedText(firstPage, trainerName, 489, yPosition, font, fontSize, maxTrainerWidth);

                function drawWrappedText(page, text, x, y, font, fontSize, maxWidth) {
                    const words = text.split(' ');
                    const lines = [];
                    let line = '';

                    for (let word of words) {
                        const testLine = line ? `${line} ${word}` : word;
                        const testWidth = font.widthOfTextAtSize(testLine, fontSize);
                        if (testWidth <= maxWidth) {
                            line = testLine;
                        } else {
                            if (line) lines.push(line);
                            line = word;
                        }
                    }
                    if (line) lines.push(line);

                    let currentY = y;
                    for (const lineText of lines) {
                        const textWidth = font.widthOfTextAtSize(lineText, fontSize);
                        const centeredX = x + (maxWidth - textWidth) / 2;

                        page.drawText(lineText, {
                            x: centeredX,
                            y: currentY,
                            size: fontSize,
                            font: font,
                        });

                        currentY -= fontSize + 1;
                    }

                    return lines.length * (fontSize + 1);
                }


                // Draw end date again (if needed)
                firstPage.drawText(`${schedule.endDate ? new Date(schedule.endDate).toLocaleDateString('en-GB') : 'N/A'}`, { x: 610, y: yPosition, size: fontSize, font });

                // Draw start and end times
                const startTimeText = formatTimeTo12Hour(schedule.startTime);
                const endTimeText = formatTimeTo12Hour(schedule.endTime);
                firstPage.drawText(startTimeText, { x: 375, y: yPosition + 3, size: fontSize, font });
                firstPage.drawText("TO", { x: 389, y: yPosition - 7, size: fontSize, font });
                firstPage.drawText(endTimeText, { x: 375, y: yPosition - 20, size: fontSize, font });

                // Draw venue
                const venueText = schedule.venue === 'Online/Classroom' ? 'Online' : schedule.venue;
                const maxVenueWidth = 100;
                const venueTextWidth = font.widthOfTextAtSize(venueText, 11);
                const centeredVenueX = 662 + (maxVenueWidth - venueTextWidth) / 2;
        
                firstPage.drawText(venueText, {
                  x: centeredVenueX,
                  y: yPosition,
                  size: 11,
                  font: font,
                });
              

                // Wrap Days and get height
                let fontSize1 = 10;
                if (schedule.days.length > 3) {
                    fontSize1 = 9; // Decrease font size if more than 3 days
                }

                const daysText = schedule.days.length > 0 ? schedule.days.join(", ") : "N/A";
                const daysTextHeight = drawWrappedText2(firstPage, daysText, 431, yPosition + 3, font, fontSize1);

                // Adjust yPosition based on the tallest wrapped text
                yPosition -= Math.max(moduleLineHeight, trainerTextHeight, daysTextHeight);
            });

            const pdfBytes = await pdfDoc.save();
            const blob = new Blob([pdfBytes], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            window.open(url, '_blank');
        } catch (error) {
            console.error('Error generating PDF:', error);
        }
    };


    const handleDaysChange = (event) => {
        setEditData((prevData) => ({
            ...prevData,
            days: event.target.value,
        }));
    };

    function formatTime12Hour(timeString) {
        const [hours, minutes] = timeString.split(':');
        const date = new Date();
        date.setHours(parseInt(hours), parseInt(minutes));

        const options = {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
        };

        return date.toLocaleTimeString('en-US', options).toUpperCase(); // <-- ensures AM/PM is uppercase
    }


    return (
        <>
            <div className='container-responsive' >

                {/* <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}> */}
                {/* Button on the left side */}
                <Button
                    variant="contained"
                    onClick={handleDownloadPDF}
                    style={{ marginBottom: '20px', alignSelf: 'flex-start', backgroundColor: buttonBackgroundColor }} // This moves the button to the left
                >
                    Download PDF
                </Button>

                {/* Table Container */}
                <TableContainer
                    component={Paper}
                    style={{
                        boxShadow: '0 3px 10px rgba(0,0,0,0.2)',
                        borderRadius: '8px',
                        maxHeight: '500px',  // Set a max height for the container
                        overflowY: 'auto',   // Enable vertical scrolling for the table body
                    }}
                >
                    <Table style={{ width: "1290px" }}>
                        <TableHead>
                            <TableRow
                                style={{
                                    backgroundColor: '#f5f5f5',
                                    position: 'sticky',
                                    top: 0,
                                    zIndex: 1, // Ensure it stays above the table body when scrolling
                                }}
                            >
                                <TableCell style={{ fontWeight: "bold" }} >S.No</TableCell>
                                <TableCell style={{ fontWeight: "bold" }} >Module Name</TableCell>
                                <TableCell style={{ fontWeight: "bold" }} >Start Date</TableCell>
                                <TableCell style={{ fontWeight: "bold" }} >End Date</TableCell>
                                <TableCell style={{ fontWeight: "bold" }} >Time</TableCell>
                                <TableCell style={{ fontWeight: "bold" }} >Days</TableCell>
                                <TableCell style={{ fontWeight: "bold" }} >Trainer</TableCell>
                                <TableCell style={{ fontWeight: "bold" }} >Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {timetableData?.scheduleDateDetails.map((schedule, index) => {
                                const matchingModule = timetableData.moduleDetails.find(
                                    (module) => module.id === schedule.startModulus
                                );
                                return (
                                    <TableRow key={schedule.id}>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>{matchingModule?.moduleName || 'N/A'}</TableCell>
                                        <TableCell>{new Date(schedule.startDate).toLocaleDateString('en-GB')}</TableCell>
                                        <TableCell>{new Date(schedule.endDate).toLocaleDateString('en-GB')}</TableCell>
                                        <TableCell>{formatTime12Hour(schedule.startTime)} TO {formatTime12Hour(schedule.endTime)}</TableCell>
                                        <TableCell>{schedule.days ? schedule.days.join(', ') : 'No days selected'}</TableCell>
                                        <TableCell>{removeBracketedText(schedule.trainer)}</TableCell>
                                        <TableCell>
                                            <Button variant="outlined" onClick={() => handleEditClick(schedule)} style={{ backgroundColor: buttonBackgroundColor, color: 'white' }}>
                                                Edit
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>

            {/* Edit Dialog */}
            <Dialog open={isEditOpen} onClose={() => setIsEditOpen(false)}>
                <DialogTitle>Edit Schedule</DialogTitle>
                <DialogContent>
                    <TextField
                        margin="dense"
                        label="Start Date"
                        type="date"
                        value={editData.startDate}
                        onChange={(e) => setEditData({ ...editData, startDate: e.target.value })}
                        fullWidth
                    />
                    <TextField
                        margin="dense"
                        label="End Date"
                        type="date"
                        value={editData.endDate}
                        onChange={(e) => setEditData({ ...editData, endDate: e.target.value })}
                        fullWidth
                    />
                    <TextField
                        margin="dense"
                        label="Start Time"
                        type="time"
                        value={editData.startTime}
                        onChange={(e) => setEditData({ ...editData, startTime: e.target.value })}
                        fullWidth
                    />
                    <TextField
                        margin="dense"
                        label="End Time"
                        type="time"
                        value={editData.endTime}
                        onChange={(e) => setEditData({ ...editData, endTime: e.target.value })}
                        fullWidth
                    />
                    <FormControl fullWidth sx={{ mt: 1 }}>
                        <InputLabel>Days</InputLabel>
                        <Select
                            multiple
                            label="Days"
                            value={editData.days}
                            onChange={handleDaysChange}
                            renderValue={(selected) => selected.join(', ')}
                        >
                            {daysOfWeek.map((day) => (
                                <MenuItem key={day} value={day}>
                                    {day}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => setIsEditOpen(false)}
                        sx={{ backgroundColor: 'error.main', color: 'white', '&:hover': { backgroundColor: 'error.dark' } }}
                    >
                        Cancel
                    </Button>

                    <Button
                        onClick={handleSaveEdit}
                        sx={{ backgroundColor: 'success.main', color: 'white', '&:hover': { backgroundColor: 'success.dark' } }}
                    >
                        Save
                    </Button>

                </DialogActions>
            </Dialog>


            <ToastContainer />
        </>
    );
};

export default Timetable;
